<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetTelegram } from '~/components/widget/telegram'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetSeoContent } from '~/components/widget/seo'
import { FeatureReviewsAddForm } from '~/components/feature/reviews'

const { t } = useI18n()
const config = useRuntimeConfig()

// Ratings are behind a global kill switch; this page must not bypass it.
if (!config.public.widgetRatingEnabled) {
  throw createError({ statusCode: 404, statusMessage: 'Not Found' })
}

useServerSeoMeta({
  title: () => t('page.reviews.add.title'),
  description: () => t('page.reviews.add.description')
})

// An interactive form renders no server content, so there is nothing to index.
useHead({
  meta: [{ name: 'robots', content: 'noindex, follow' }]
})

const breadcrumbs = computed(() => [
  { title: t('page.reviews.add.breadcrumb'), url: '/reviews/add' }
])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetCustomerCare />
            <WidgetTelegram />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="space-y-5" role="main">
          <WidgetSeoContent
            position="upper"
            :title="$t('page.reviews.add.heading')"
            :description="$t('page.reviews.add.intro')"
          />
          <FeatureReviewsAddForm />
          <WidgetSeoContent position="bottom" />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
